import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TokenStorageService } from '@service/token-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ExIS';
  auth: boolean = false;

  constructor(
    private tokenStorageService: TokenStorageService,
    router: Router,
  ) {
    router.events.subscribe({
      next: (value) => {
        if (value instanceof NavigationEnd) {
          const url: URL = new URL(value.url, "https://exis");
          if (url.pathname === "/auth") {
            this.auth = true;
          } else {
            const isLogged = this.tokenStorageService.isLogged();
            if (!isLogged) {
              if (isLogged === false) {
                if (environment.loginUrl) {
                  window.location.href = environment.loginUrl;
                }
              }
            }
          }
        }
      }
    });
  }

  ngOnInit(): void {
  }

  get logged(): boolean | null {
    return this.tokenStorageService.isLogged()
  }
}
